import { render, staticRenderFns } from "./KeywordsPhoneCategory.vue?vue&type=template&id=394329b4"
import script from "./KeywordsPhoneCategory.vue?vue&type=script&lang=js"
export * from "./KeywordsPhoneCategory.vue?vue&type=script&lang=js"
import style0 from "./KeywordsPhoneCategory.vue?vue&type=style&index=0&id=394329b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports